import Spinner from '@components/Spinner'
import React from 'react'
import { Container, Label } from './PageLoader.styles'

interface PageLoaderProps {
	label?: string
}

const PageLoader: React.FC<PageLoaderProps> = ({ label = 'Loading…' }) => (
	<Container>
		<Spinner />
		<Label>{label}</Label>
	</Container>
)

export default PageLoader
